import type { ReactNode } from 'react'
import { useI18n, type MessageKey } from '@/i18n'
import { Icon, V1Sprite } from '@/features/gate/v1/kit'
import { C } from '@/features/gate/v1/style'

/**
 * The title row of a phone screen in the alignment map's look (the V1 boards' header): a round
 * back button, the title in the language on screen, a quieter line under it, and room on the right.
 */
export function ScreenTitle({
  title,
  sub,
  onBack,
  aside,
}: {
  title: MessageKey
  sub?: ReactNode
  /** Leave out for no back button. */
  onBack?: () => void
  aside?: ReactNode
}) {
  const { t } = useI18n()
  return (
    <div data-v1-screen style={{ display: 'flex', alignItems: 'center', gap: 10, color: C.ink }}>
      <V1Sprite />
      {onBack && (
        <button
          type="button"
          aria-label={t('common.back')}
          onClick={onBack}
          style={{
            width: 48,
            height: 48,
            flexShrink: 0,
            borderRadius: 24,
            border: `1.5px solid ${C.border}`,
            background: C.surface,
            color: C.ink,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            cursor: 'pointer',
          }}
        >
          <Icon name="back" />
        </button>
      )}
      <span style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
        <h1 style={{ margin: 0, fontSize: 21, lineHeight: 1.2, fontWeight: 700 }}>{t(title)}</h1>
        {sub && <span style={{ fontSize: 15, color: C.muted, lineHeight: 1.3 }}>{sub}</span>}
      </span>
      {aside}
    </div>
  )
}
